import {
  Box,
  ColorProperty,
  FlexAnchor,
  FlexAnchorProps,
  Icon,
  IconProperty,
  IconsTheme,
  smBumps,
  Typo,
} from '@wrisk/ui-components'
import React from 'react'

import { ConditionalCover } from '../../../domain'
import {
  tCovers,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { useConditionalCoverModal } from './useConditionalCoverModal'

interface ConditionalCoverItemProps extends Omit<FlexAnchorProps, 'ref'> {
  conditionalCover: ConditionalCover
  iconSize?: IconProperty
}

export const ConditionalCoverItem: React.FC<ConditionalCoverItemProps> = ({
  conditionalCover,
  typoSize,
  iconSize,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const showConditionalModal = useConditionalCoverModal()

  const { icon, color }: { icon: keyof IconsTheme; color: ColorProperty } =
    conditionalCover.active
      ? {
          icon: 'tick',
          color: 'body',
        }
      : {
          icon: 'cross',
          color: 'bodySecondary',
        }

  return (
    <FlexAnchor
      variant='highlight'
      flexWrap='nowrap'
      py={3}
      px={smBumps}
      onClick={() => showConditionalModal(conditionalCover)}
      {...props}
    >
      <Box mr={2} display='flex' flexDirection='row' flexWrap='nowrap'>
        <Icon icon={icon} color={color} mr={smBumps} size={iconSize ?? 'medium'} />
        <Typo wordWrap='break-word' typoSize={typoSize} color={color}>
          {t(tCovers(conditionalCover.coverCode, 'name'))}
        </Typo>
      </Box>
      <Icon icon='info' size='tiny' />
    </FlexAnchor>
  )
}
